<template>
  <div class="modal-sidebar__cats">
    <a href="javascript:;" class="font-size-16 font-sanpro primary-color modal-sidebar__cats__back display-block" @click="handleBackBookList">
      <span class="icon-arrow-left primary-color font-size-12"><span class="path1 priamry-color"></span><span class="path2 priamry-color"></span></span> 
      Trở lại
    </a>
    <div class="modal-sidebar__cats__list">
      <b-card
        no-body
        v-for="(item, index) in bookCats"
        class="card-item border-0 bg-transparent"
        :class="{'active ': collapseOpen === `cat_${item.bookIndexId}`}"
        :key="index" v-show="item.countQuestionTeacher"
      >
        <div class="card-wrap display-block">
          <b-card-header
            header-tag="header"
            role="tab"
            class="p-0 bg-transparent border-0"
          >
            <div 
              class="cat-head display-flex justify-content-md-between full-width"
              :class="{'active font-sanpro-semibold primary-color': collapseOpen === `cat_${item.bookIndexId}` || catCurrent && ((catCurrent.bookIndexId === item.bookIndexId) || (!catCurrent.catParentFirst && catCurrent.catParent === item.bookIndexId))}" :id="`cat_row_${item.bookIndexId}`"
            >
              <span class="margin-0 font-family-Semibold font-size-16 title-sidebar cursor-pointer" @click="openCollapse(`cat_${item.bookIndexId}`, item)">
                {{ item.title }}
                <span class="cat-space-title" v-if="item.title">:</span>
                {{ item.name }} 
              </span>
            </div>
          </b-card-header>
          <b-collapse v-if="item.bookIndexChilds.length > 0" :id="`cat_${item.bookIndexId}`" accordion="my-accordion" role="tabpanel">
            <b-card-body class="modal-sidebar__cats__card__body">
              <ul class="cat-child margin-0 p-0">
                <li class="d-block" v-for="(child, pos) of item.bookIndexChilds" :id="`cat_row_${child.bookIndexId}`" :key="pos" v-show="child.countQuestionTeacher">
                  <a
                    href="javascript:;"
                    class="font-size-16 display-flex justify-content-between full-width"
                    :class="`${catCurrent && ((catCurrent.bookIndexId === child.bookIndexId) || (catCurrent.catParentFirst && catCurrent.catParent === child.bookIndexId)) ? 'active font-sanpro-semibold primary-color' : 'font-sanpro secondary-color-txt '}`"
                  >
                    <!-- :class="{'active font-sanpro-semibold primary-color': catCurrent && ((catCurrent.bookIndexId === child.bookIndexId) || (catCurrent.catParentFirst && catCurrent.catParent === child.bookIndexId))}" -->
                      <span @click="openCollapse(`cat_child_${child.bookIndexId}`, child)">
                        {{ child.title }}
                        <span class="cat-space-title" v-if="child.title">:</span>
                        {{ child.name }}
                      </span>
                  </a>
                  <b-collapse v-if="child.bookIndexChilds.length > 0" :id="`cat_child_${child.bookIndexId}`" accordion="my-accordion-child" role="tabpanelchild">
                    <b-card-body class="modal-sidebar__cats__card__body">
                      <ul class="cat-child margin-0 p-0 list-style-none">
                        <li v-for="(child2, loc) of child.bookIndexChilds" :id="`cat_row_${child2.bookIndexId}`" :key="loc" v-show="child2.countQuestionTeacher">
                          <a
                            href="javascript:;"
                            class="font-size-16 display-flex justify-content-between full-width"
                            :class="`${child2.bookIndexId === checkActive ? 'active font-sanpro-semibold primary-color' : 'font-sanpro secondary-color-txt '}`"
                            @click="handleCheckActive(child2.bookIndexId)"
                          >
                            <!-- :class="{'active font-sanpro-semibold primary-color': child2.bookIndexId === checkActive}" -->
                            <!-- @click="getQuestions(child2.bookIndexId, child2, true)" -->
                            <!-- check active của a thịnh -->
                            <!-- catCurrent && catCurrent.bookIndexId === child2.bookIndexId -->
                            <span @click="handleFilterQuestions(child2.bookIndexId, child2)">
                              {{ child2.title }}
                              <span class="cat-space-title" v-if="child2.title">:</span> 
                              {{ child2.name }}
                            </span>
                          </a>
                        </li>
                      </ul>
                    </b-card-body>
                  </b-collapse>
                </li>
              </ul>
            </b-card-body>
          </b-collapse>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { STORE_KEY } from './../../_store/constants'
import mixinExercise from '@/modules/exercises/_store/mixinExercise'
import { getCategoriesByBook } from '@/modules/exercises/_api'
import { apiGetListQuestionByBookIndexId } from './../../_api/exam'

export default {
  name: 'SidebarCatsOfBook',
  mixins: [ mixinExercise ],
  props: {
    keyword: String
  },
  data () {
    return {
      bookCats: [],
      catCurrent: {},
      catsFlat: [],
      catsLength: 0,
      firstloadData: true,
      collapseOpen: '',
      checkActive: 0
    }
  },
  computed: {
    ...mapState(STORE_KEY, ['bookIdQuestions', 'bookIndexIdQuestions'])
  },
  watch: {
    keyword (newVal) {
      this.handleFilterQuestions(this.bookIndexIdQuestions)
    }
  },
  mounted () {
    this.getCats()
  },
  methods: {
    ...mapActions('common', ['setLoading']),
    ...mapActions(STORE_KEY, ['acSetBookIndexIdFilterQuestions', 'acSetBookIdFilterQuestions', 'acSetQuestionSample']),    

    getCats () {
      let self = this
      if (self.bookIdQuestions) {
        self.setLoading(true)
        getCategoriesByBook(self.bookIdQuestions).then(async res => {
          if(res && res.data && !res.errors && res.data.length > 0) {
            self.handleFilterQuestions(res.data[0].bookIndexId, res.data[0])
            self.bookCats = res.data
            self.catsFlat = await self.flatenCats(res.data)
          }
        }).finally(() => self.setLoading(false))
      }
    },

    openCollapse(id, cat) {
      this.handleFilterQuestions(cat.bookIndexId, cat)
      // this.catCurrent = cat
      // cat.bookIndexChilds.length > 0 && this.setCatDataCurr(cat)
      this.setCatDataCurr(cat)
    },

    handleCheckActive(id){
      this.checkActive = id
    },

    setCatDataCurr(data) {
      let self = this;
      this.catCurrent = data
      let indexCatInCatsFlat = self.catsFlat.findIndex(cat => cat.bookIndexId === data.bookIndexId);
      let dataCat = self.catsFlat[indexCatInCatsFlat];

      if(self.firstloadData) {
        if(dataCat.catParentFirst && dataCat.catParent) {
          this.$root.$emit('bv::toggle::collapse', `cat_${dataCat.catParentFirst}`);
          this.$root.$emit('bv::toggle::collapse', `cat_child_${dataCat.catParent}`);
        } else if (!dataCat.catParentFirst && dataCat.catParent) {
            this.$root.$emit('bv::toggle::collapse', `cat_${dataCat.catParent}`)
        } else if(!dataCat.catParentFirst && !dataCat.catParent) {
          this.$root.$emit('bv::toggle::collapse', `cat_${dataCat.bookIndexId}`);
        }
        self.firstloadData = false;
      } else {
        if (!dataCat.catParentFirst && dataCat.catParent && data.bookIndexChilds && data.bookIndexChilds.length) {
          this.$root.$emit('bv::toggle::collapse', `cat_child_${dataCat.bookIndexId}`);
        } else if(!dataCat.catParentFirst && !dataCat.catParent && data.bookIndexChilds && data.bookIndexChilds.length) {
          this.$root.$emit('bv::toggle::collapse', `cat_${dataCat.bookIndexId}`);
        } 
      }
    },

    handleFilterQuestions (bookIndexId, cat = null) {
      let self = this
      self.setLoading(true)
      self.acSetBookIndexIdFilterQuestions(bookIndexId)
      // Reset question current
      self.acSetQuestionSample([])
      apiGetListQuestionByBookIndexId(bookIndexId, self.keyword).then(res => {
        // console.log('Get question: ', res.data, self.catsFlat, bookIndexId)
        if (res && res.data && res.data.length > 0 && !res.errors) {
          self.acSetQuestionSample(res.data)
        } else if (self.catsFlat.length > 0 && cat) {
          let lengthCatsFlat = self.catsFlat.length
          let indexCatCurr = self.catsFlat.findIndex(catF => catF.bookIndexId === cat.bookIndexId)
          // console.log(self.catsFlat[indexCatCurr + 1].bookIndexId)
          indexCatCurr > -1 && indexCatCurr < lengthCatsFlat -1 && self.openCollapse(self.catsFlat[indexCatCurr + 1].bookIndexId, self.catsFlat[indexCatCurr + 1])
        }
      }).finally(() => self.setLoading(false))
    },

    handleBackBookList () {
      this.acSetBookIdFilterQuestions(0)
      this.acSetBookIndexIdFilterQuestions(0)
    }
  }
}
</script>

<style lang="scss" scoped>
.card-item {
  margin-bottom: 10px;
  ul {
    li {
      &:not(:last-child) {
        margin-bottom: 10px;
      }
    }
  }
}
.modal-sidebar__cats {
  
  &__card__body {
    padding: 5px 1.25em;
  }
}
// .modal-sidebar__cats{
//   &__list{
//     .border-0{
//       background: none;
//     }
//   }
// }
// .active{
//   color: #0f3dba !important;
//   font-family: 'sandisplaypro-semi';
//   .title-sidebar{
//     color: #0f3dba !important;
//     font-family: 'sandisplaypro-semi';
//   }
// }
</style>